module.exports = __webpack_public_path__ + "img/ydd_qyh_title.fdd29214.png";